
  document.addEventListener('DOMContentLoaded', function () {
    // --- VIDEO SWIPER ---
    const videoSwiper = new Swiper('.smarte-video-reel .smarte-video-reel-swiper', {
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: 6.8,
      loop: true,
      spaceBetween: 0,
                  navigation: {
    nextEl: '.swiper-button-next-smarte-video',
    prevEl: '.swiper-button-prev-smarte-video',
  },
            breakpoints: {
        1024: {
          slidesPerView: 5.8,
          loopedSlides: 6,
        },
        701: {
          slidesPerView: 3.8,
          loopedSlides: 3,
        },
        101: {
          slidesPerView: 1.5,
          loopedSlides: 2,
        },
      },
      on: {
        init: function () {
          handleVideos(this);
          updateProgress(this);
        },
        slideChange: function () {
          handleVideos(this);
          updateProgress(this);
        },
      },
    });

    function handleVideos(swiper) {
      swiper.slides.forEach((slide, index) => {
        const video = slide.querySelector('video');
        if (!video) return;

        if (index === swiper.activeIndex) {
          video.style.display = 'block';
          video.play().catch(() => {});
        } else {
          video.pause();
          video.currentTime = 0;
          video.load();
        }
      });
    }

    function updateProgress(swiper) {
      const progressFill = swiper.el.closest('.smarte-video-reel').querySelector('.swiper-progress-fill');
      if (!progressFill) return;

      const totalSlides = swiper.slides.length - (swiper.loopedSlides || 0) * 2;
      const currentIndex = swiper.realIndex + 1;
      progressFill.style.width = (currentIndex / totalSlides) * 100 + '%';
    }

    // --- PATTERN SWIPER ---
    const patternSwiper = new Swiper('.smarte-pattern-reel .smarte-pattern-reel-swiper', {
      loop: true,
      slidesPerGroup: 1,
      slidesPerView: 10.5,
      spaceBetween: 10,
      centeredSlides: true,
            navigation: {
    nextEl: '.swiper-button-next-smarte',
    prevEl: '.swiper-button-prev-smarte',
  },
      breakpoints: {
        1024: {
          slidesPerView: 10.5,
          loopedSlides: 6,
        },
        701: {
          slidesPerView: 4.5,
          loopedSlides: 3,
        },
        101: {
          slidesPerView: 2.9,
          loopedSlides: 4,
        },
      },
    });

    setTimeout(() => {
      patternSwiper.update();
      patternSwiper.slideToLoop(0);
    }, 100);
  });
  

